<div class="batchinfo">

    <!-- Sense capçalera pròpia: la referència/descripció ja surten a la línia, repetir-les hi sobrava. -->
    <div class="batchinfo-header" *ngIf="!readonly">
        <actions [actionstrip]="batchActions" (clickAction)="onBatchAction($event)"></actions>
    </div>

    <div class="batchinfo-table" *ngIf="details.length > 0">
        <div class="batchinfo-row batchinfo-columns">
            <div class="col batchNumber">{{ 'DELIVERYLINE.BATCHINFO.BATCHNUMBER.CAPTION' | translate }}</div>
            <div class="col manufacturingDate">{{ 'DELIVERYLINE.BATCHINFO.MANUFACTURINGDATE.CAPTION' | translate }}</div>
            <div class="col expirationDate">{{ 'DELIVERYLINE.BATCHINFO.EXPIRATIONDATE.CAPTION' | translate }}</div>
            <div class="col number">{{ 'DELIVERYLINE.BATCHINFO.BOXQUANTITY.CAPTION' | translate }}</div>
            <div class="col number">{{ 'DELIVERYLINE.BATCHINFO.UNITQUANTITY.CAPTION' | translate }}</div>
            <div class="col number">{{ 'DELIVERYLINE.BATCHINFO.GROSSWEIGHT.CAPTION' | translate }}</div>
            <div class="col number">{{ 'DELIVERYLINE.BATCHINFO.NETWEIGHT.CAPTION' | translate }}</div>
            <div class="col actions"></div>
        </div>

        <div class="batchinfo-row" *ngFor="let detail of details">

            <div class="col batchNumber">
                <input-component *ngIf="!readonly" [(ngModel)]="detail.batchNumber" name="batchNumber"
                    autocomplete="off" [readonly]="readonly" (valueChanged)="onValueChanged()">
                </input-component>
                <span *ngIf="readonly">{{ detail.batchNumber }}</span>
            </div>

            <div class="col manufacturingDate">
                <date-picker *ngIf="!readonly" [(ngModel)]="detail.manufacturingDate" name="manufacturingDate"
                    [readonly]="readonly" (valueChanged)="onValueChanged()">
                </date-picker>
                <span *ngIf="readonly">{{ detail.manufacturingDate | date }}</span>
            </div>

            <div class="col expirationDate">
                <date-picker *ngIf="!readonly" [(ngModel)]="detail.expirationDate" name="expirationDate"
                    [readonly]="readonly" (valueChanged)="onValueChanged()">
                </date-picker>
                <span *ngIf="readonly">{{ detail.expirationDate | date }}</span>
            </div>

            <div class="col number">
                <input-component *ngIf="!readonly" [(ngModel)]="detail.boxQuantity" name="boxQuantity" type="number"
                    [min]="0" autocomplete="off" [readonly]="readonly" (valueChanged)="onValueChanged()">
                </input-component>
                <span *ngIf="readonly">{{ detail.boxQuantity | number }}</span>
            </div>

            <div class="col number">
                <input-component *ngIf="!readonly" [(ngModel)]="detail.unitQuantity" name="unitQuantity" type="number"
                    [min]="0" autocomplete="off" [readonly]="readonly" (valueChanged)="onValueChanged()">
                </input-component>
                <span *ngIf="readonly">{{ detail.unitQuantity | number }}</span>
            </div>

            <div class="col number">
                <input-component *ngIf="!readonly" [(ngModel)]="detail.grossWeightInKg" name="grossWeightInKg"
                    type="number" [min]="0" [step]="0.1" autocomplete="off" [readonly]="readonly"
                    (valueChanged)="onValueChanged()">
                </input-component>
                <span *ngIf="readonly">{{ detail.grossWeightInKg | number }}</span>
            </div>

            <div class="col number">
                <input-component *ngIf="!readonly" [(ngModel)]="detail.netWeightInKg" name="netWeightInKg"
                    type="number" [min]="0" [step]="0.1" autocomplete="off" [readonly]="readonly"
                    (valueChanged)="onValueChanged()">
                </input-component>
                <span *ngIf="readonly">{{ detail.netWeightInKg | number }}</span>
            </div>

            <div class="col actions">
                <i class="fa fa-trash-o deleteBatch" *ngIf="!readonly" (click)="onDeleteBatch(detail)"
                    aria-hidden="true"></i>
            </div>
        </div>
    </div>

    <div class="batchinfo-summary" *ngIf="details.length > 0">
        <span class="summary-item">
            {{ 'DELIVERYLINE.BATCHINFO.TOTALBATCHES.CAPTION' | translate }}
            <b>{{ batchCount | number }}</b>
        </span>
        <span class="summary-item" [class.mismatch]="boxQuantityMismatch">
            {{ 'DELIVERYLINE.BATCHINFO.BOXQUANTITY.CAPTION' | translate }}
            <b>{{ totalBoxQuantity | number }}</b>
            <span *ngIf="expectedBoxQuantity != null"> / {{ expectedBoxQuantity | number }}</span>
        </span>
        <span class="summary-item">
            {{ 'DELIVERYLINE.BATCHINFO.NETWEIGHT.CAPTION' | translate }}
            <b>{{ totalNetWeightInKg | number }}</b>
        </span>
    </div>

</div>
